'use client';

import React from 'react';

export function LegoBag({ bagNumber, width = 200, height = 220, noMargin = false, isVirtual = false, ...props }) {
  return (
    <div style={{ marginLeft: noMargin ? '0' : '-59px', display: 'block', lineHeight: 0 }}>
    <svg
      width={width}
      height={height}
      viewBox="0 0 200 220"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <filter id="blurry-bricks">
          <feGaussianBlur in="SourceGraphic" stdDeviation="5" />
        </filter>
      </defs>
      <path
        d="M 20 10 C 10 10, 10 20, 10 30 L 10 200 C 10 210, 20 210, 20 210 L 180 210 C 190 210, 190 200, 190 200 L 190 30 C 190 20, 190 10, 180 10 Z M 60 10 L 60 30 L 140 30 L 140 10 Z"
        fill={isVirtual ? '#E8F4FD' : '#E0E0E0'}
        fillOpacity={isVirtual ? 0.6 : 0.4}
        stroke={isVirtual ? '#228be6' : '#7d7d7d'}
        strokeWidth="1.5"
        strokeDasharray={isVirtual ? '8 4' : 'none'}
      />
      {!isVirtual && (
        <path
          d="M 40 120 L 70 110 L 80 140 L 50 150 Z M 90 90 L 120 80 L 140 110 L 110 120 Z M 70 160 L 100 150 L 120 180 L 90 190 Z M 130 130 L 160 120 L 170 150 L 140 160 Z"
          fill="#000000"
          fillOpacity="0.1"
          filter="url(#blurry-bricks)"
        />
      )}

      <rect
        x="55"
        y="80"
        width="90"
        height="60"
        rx="5"
        fill="white"
      />

      <text
        x="100"
        y="112"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize="48"
        fontWeight="bold"
        fill={isVirtual ? '#228be6' : 'black'}
        textAnchor="middle"
        dominantBaseline="central"
      >
        {bagNumber}
      </text>
    </svg>
    </div>
  );
}
